import { defineStore } from 'pinia'
import { useEventsStore } from '../events'

export const useCommonAuthStore = defineStore('commonAuth', () => {
  const logoutClean = () => {
    const eventStore = useEventsStore()

    // Clean all the active stores except config anf featureFlag
    eventStore.$resetAllStores(['config', 'featureFlag'])

    // Clean Event source
    eventStore.close()
  }

  // STORE RESET
  // Used to reset the store (is given by default by pinia on options api stores but not on composition api stores)
  const $reset = () => {}

  return {
    logoutClean,
    $reset,
  }
})
